
    (window.__NEXT_P=window.__NEXT_P||[]).push(["/confirmed", function() {
      var page = require("/Users/andym/Development/Active/Website/pages/confirmed.js")
      if(module.hot) {
        module.hot.accept("/Users/andym/Development/Active/Website/pages/confirmed.js", function() {
          if(!next.router.components["/confirmed"]) return
          var updatedPage = require("/Users/andym/Development/Active/Website/pages/confirmed.js")
          next.router.update("/confirmed", updatedPage.default || updatedPage)
        })
      }
      return { page: page.default || page }
    }]);
  